import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { injectable } from 'tsyringe';
import { createElement } from '@gn-audio/core/common/templating';
import { BasketPlugin } from '../../models';
import { emulateClickWhenEnterOrSpacePressed } from '../../utilities';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import { BasketCouponListComponent } from './components';
import './basket-coupon-code.plugin.scss';
import template from './basket-coupon-code.plugin.html';
var BasketCouponCodePlugin = /** @class */ (function (_super) {
    __extends(BasketCouponCodePlugin, _super);
    function BasketCouponCodePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeysPressesOnActionButton = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.action);
        };
        _this.showCouponInput = function () {
            _this.action.classList.add("hidden" /* CssClass.Hidden */);
            _this.content.classList.add("visible" /* CssClass.Visible */);
        };
        _this.onApplyCode = function () {
            var _a;
            _this.error.classList.remove("visible" /* CssClass.Visible */);
            var coupon = ((_a = _this.input) === null || _a === void 0 ? void 0 : _a.value) || '';
            if (!coupon) {
                return;
            }
            _this.eventBus.post("apply-coupon" /* BasketEvent.ApplyCoupon */, coupon);
        };
        /**
         * Handles Enter and Esc key codes.
         * On `Enter` code will be applied.
         * On `Esc` plugin will be restored to initial state.
         * @param event Keyboard event
         */
        _this.handleCodeInput = function (event) {
            var key = event.key;
            if (key === "Enter" /* KeyboardCode.Enter */) {
                _this.onApplyCode();
            }
            else if (key === "Escape" /* KeyboardCode.Esc */) {
                _this.reset();
            }
        };
        _this.reset = function () {
            _this.error.classList.remove("visible" /* CssClass.Visible */);
            _this.action.classList.remove("hidden" /* CssClass.Hidden */);
            _this.content.classList.remove("visible" /* CssClass.Visible */);
            _this.input.value = '';
        };
        _this.onRemoveCode = function (coupon) {
            _this.eventBus.post("remove-coupon" /* BasketEvent.RemoveCoupon */, coupon.coupon_item_id);
        };
        _this.reactOnError = function (exception) {
            if (!exception || exception.type !== "InvalidCouponCodeException" /* BasketExceptionType.InvalidCouponCodeException */) {
                return;
            }
            _this.error.classList.add("visible" /* CssClass.Visible */);
        };
        _this.reactOnChanges = function (state) {
            var _a;
            _this.list.destroy();
            var totalCount = getBasketTotalCount(state);
            if (totalCount > 0) {
                _this.element.classList.add("visible" /* CssClass.Visible */);
            }
            else {
                _this.element.classList.remove("visible" /* CssClass.Visible */);
            }
            var hasCouponItems = ((_a = state.coupon_items) === null || _a === void 0 ? void 0 : _a.length) > 0;
            if (hasCouponItems) {
                // Display coupon items if there are any applied.
                _this.list.render({
                    container: _this.listContainer,
                    data: state.coupon_items || [],
                    translations: _this.translations,
                    onRemove: _this.onRemoveCode,
                });
                // Set "coupon code applied" state on elements.
                _this.error.classList.remove("visible" /* CssClass.Visible */);
                _this.action.classList.add("hidden" /* CssClass.Hidden */);
                _this.content.classList.remove("visible" /* CssClass.Visible */);
            }
            else {
                _this.reset();
            }
            // If there are no products in the basket but there are coupon codes applied
            // coupon codes must be detached.
            if (totalCount === 0 && hasCouponItems) {
                _this.onRemoveCode(state.coupon_items[0]);
            }
        };
        return _this;
    }
    BasketCouponCodePlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            var target;
            return __generator(this, function (_b) {
                this.eventBus = eventBus;
                this.translations = translations;
                this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                this.eventBus.subscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.reactOnError);
                this.element = createElement(template, {}, this.translations);
                target = document.querySelector(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */);
                target.insertAdjacentElement('afterbegin', this.element);
                this.content = this.element.querySelector('.basket-coupon-code');
                this.error = this.element.querySelector('.basket-coupon-code-error');
                this.input = this.element.querySelector('.basket-coupon-code__input');
                this.input.addEventListener('keydown', this.handleCodeInput);
                this.button = this.element.querySelector('.basket-coupon-code__button');
                this.button.addEventListener('click', this.onApplyCode);
                this.action = this.element.querySelector('.basket-coupon-code-action');
                this.action.addEventListener('click', this.showCouponInput);
                this.action.addEventListener('keydown', this.handleKeysPressesOnActionButton);
                this.listContainer = this.element.querySelector('.basket-coupon-code-list');
                this.list = new BasketCouponListComponent();
                this.reactOnChanges(state);
                return [2 /*return*/];
            });
        });
    };
    BasketCouponCodePlugin.prototype.shouldRegister = function () {
        return true;
    };
    BasketCouponCodePlugin.prototype.unregister = function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                (_a = this.list) === null || _a === void 0 ? void 0 : _a.destroy();
                this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                this.eventBus.unsubscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.reactOnError);
                (_b = this.button) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.onApplyCode);
                (_c = this.input) === null || _c === void 0 ? void 0 : _c.removeEventListener('keydown', this.handleCodeInput);
                (_d = this.action) === null || _d === void 0 ? void 0 : _d.removeEventListener('click', this.showCouponInput);
                (_e = this.action) === null || _e === void 0 ? void 0 : _e.removeEventListener('keydown', this.handleKeysPressesOnActionButton);
                (_f = this.element) === null || _f === void 0 ? void 0 : _f.remove();
                return [2 /*return*/];
            });
        });
    };
    BasketCouponCodePlugin = __decorate([
        injectable()
    ], BasketCouponCodePlugin);
    return BasketCouponCodePlugin;
}(BasketPlugin));
export { BasketCouponCodePlugin };
